import { useCallback, useEffect, useRef, useState } from "react";

import { listCoCounsel } from "../../../api/coCounsel";

import { getCoCounselError } from "./coCounsel.mjs";

export default function useCoCounsel(clientId, caseId) {
  const [relationships, setRelationships] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const requestId = useRef(0);
  const activeCase = useRef("");
  const context = `${clientId}/${caseId}`;
  activeCase.current = context;
  const refresh = useCallback(async () => {
    if (activeCase.current !== context) return;
    const request = ++requestId.current;
    if (!clientId || !caseId) {
      setLoading(false);
      return;
    }
    setLoading(true);
    setError("");
    try {
      const data = await listCoCounsel(clientId, caseId);
      if (request !== requestId.current || activeCase.current !== context) return;
      setRelationships((data || []).filter((relationship) => relationship.status !== "removed"));
    } catch (err) {
      if (request !== requestId.current || activeCase.current !== context) return;
      setError(getCoCounselError(err, "Unable to load co-counsel firms."));
    } finally {
      if (request === requestId.current && activeCase.current === context) setLoading(false);
    }
  }, [clientId, caseId, context]);

  useEffect(() => {
    setRelationships([]);
    refresh();
    return () => {
      requestId.current++;
    };
  }, [refresh]);

  return { relationships, loading, error, refresh };
}
